/*
 * DEV-ONLY shim: Globo product-link navigation drops the port
 * ---------------------------------------------------------------------------
 * Globo's Protection option is a "product-link" — choosing UV-Rated navigates
 * to a different product. It builds that URL from `location.hostname` where it
 * needs `location.host`, so the port is lost:
 *
 *     http://127.0.0.1:9292/products/circle-stickers   (here)
 *  →  http://127.0.0.1/products/circle-stickers-uv-rated-gloss   (where it goes)
 *
 * Port 80 has nothing listening, so the preview dies with
 * ERR_CONNECTION_REFUSED. It is a bug in the app, not in this theme.
 *
 * THIS CANNOT RUN IN PRODUCTION. Storefronts are served on 443 with no port in
 * the URL, so `location.port` is empty and this file returns immediately. It
 * exists purely so the local preview and any :PORT staging URL are clickable —
 * customers never reach this code path, and the live behaviour is unchanged.
 *
 * Verified safe to intercept: cancelling the label's click in the capture phase
 * suppresses Globo's own navigation entirely (measured — no other listener
 * fires), so there is no double-navigation.
 */
(function () {
  // The whole point: no port, no problem, no shim.
  if (!window.location.port) return;

  document.addEventListener(
    'click',
    function (event) {
      var label = event.target.closest && event.target.closest('.gpo-app label');
      if (!label) return;

      var id = label.getAttribute('for');
      var input = id ? document.getElementById(id) : null;
      if (!input || input.getAttribute('data-type') !== 'product-link') return;

      var handle = input.getAttribute('data-product-handle');
      if (!handle) return;

      // Already here — let Globo do whatever it does, minus the navigation.
      var target = window.location.origin + '/products/' + handle;
      if (window.location.pathname === '/products/' + handle) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = target;
    },
    true
  );
})();
